import { render, staticRenderFns } from "./PuntiForzaGrid.vue?vue&type=template&id=365e7954"
import script from "./PuntiForzaGrid.vue?vue&type=script&lang=ts"
export * from "./PuntiForzaGrid.vue?vue&type=script&lang=ts"
import style0 from "./PuntiForzaGrid.vue?vue&type=style&index=0&id=365e7954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports